import { createAsyncThunk } from "@reduxjs/toolkit";
import { getSubjectByClassDocIdSection } from "app/services/management";
import { getAllApprovedExamList } from "app/services/schoolService/exam.service";
import { getClassDropdown } from "app/services/schoolService/school.service";

export const getAllClassDropdownThunk = createAsyncThunk(
  "examControl/getAllClassDropdowns",
  async (payload) => {
    try {
      const res = await getClassDropdown(payload.schoolDocId);
      const data = res?.data?.list;
      return data;
    } catch (e) {}
  }
);

export const getAllSubjectByClassDocId = createAsyncThunk(
  "examControl/getAllSubjectByClassDocId",
  async (payload) => {
    try {
      const res = await getSubjectByClassDocIdSection(
        payload.streamValue,
        payload.section,
        payload.session
      );
      const data = res?.data?.list;
      return data;
    } catch (e) {}
  }
);

export const getApprovedExamListByClass = createAsyncThunk(
  "examControl/getAllApprovedExamList",
  async (payload) => {
    try {
      const res = await getAllApprovedExamList({
        session: payload.session,
        classDocId: payload.classValue,
        section: payload.section,
      });
      const data = res?.data?.list;
      return data;
    } catch (e) {}
  }
);
